import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import { UIFeatherIcon, UICarbonNumberField } from '@futrli/ui-components';

import { MultiPaymentTreatment } from '../../../../types';

import styles from './multi-payment-days.scss';

interface MultiPaymentDaysProps {
  onAddNew: () => void;
  onDaysChange: (index: number, value: string) => void;
  onPercentageChange: (index: number, value: string) => void;
  multiPaymentData: MultiPaymentTreatment[];
}

export const MultiPaymentDays = ({
  onAddNew,
  onDaysChange,
  onPercentageChange,
  multiPaymentData
}: MultiPaymentDaysProps) => {
  const percentageSum = multiPaymentData.reduce((acc, curr) => {
    if (typeof curr.payment_percentage === 'string') {
      return acc + Number(curr.payment_percentage);
    }
    return acc;
  }, 0);

  return (
    <div>
      {multiPaymentData.map((d, index) => (
        <div key={index} className={styles.multiPaymentTreatmentItem}>
          <>
            <div className={styles.flexContainer}>
              <FormattedMessage id="common.in_number_of_days_weeks_months_years" defaultMessage="In" />
              <UICarbonNumberField
                className={styles.smallInput}
                autoComplete="off"
                type="number"
                onChange={value => onDaysChange(index, value)}
                id="single-payment-term"
                name="single-payment-term"
                value={d.payment_terms}
                clampMin={0}
                maxDecimals={0}
                placeholder="50"
                style={{ margin: '0 20px' }}
                size="large"
                mb={0}
              />
              <FormattedMessage
                id="common.days"
                defaultMessage="days"
                // values={{ period: paymentTreatment === PaymentTreatment.MULTI_PAYMENT_DAYS ? 'days' : 'weeks' }}
              />
            </div>
            <div className={styles.flexContainer}>
              <UICarbonNumberField
                className={styles.smallInput}
                autoComplete="off"
                onChange={value => onPercentageChange(index, value)}
                id="single-payment-term"
                name="single-payment-term"
                value={d.payment_percentage}
                clampMin={0}
                maxDecimals={0}
                placeholder="45"
                style={{ marginRight: 20 }}
                size="large"
                mb={0}
              />
              {'%'}
            </div>
          </>
          {/* {index === 0 ? (
          <>
            <div className={styles.flexContainer}>
              <UITextField
                value={d.days}
                InputProps={{
                  classes: { root: styles.smallInput }
                }}
                placeholder="10"
                style={{ marginRight: 20, marginLeft: 33 }}
                onChange={e => onDaysChange(index, e)}
              />
              <FormattedMessage
                id="predict.predictions.days_before"
                defaultMessage="{period} before"
                values={{ period: paymentTreatment === PaymentTreatment.MULTI_PAYMENT_DAYS ? 'days' : 'weeks' }}
              />
            </div>
            <div className={styles.flexContainer}>
              <UITextField
                value={d.percentage}
                InputProps={{
                  classes: { root: styles.smallInput }
                }}
                placeholder="5"
                onChange={e => onPercentageChange(index, e)}
                style={{ marginRight: 20 }}
              />
              %
            </div>
          </>
        ) : (
          <>
            <div className={styles.flexContainer}>
              <FormattedMessage id="common.in_number_of_days_weeks_months_years" defaultMessage="In" />
              <UITextField
                value={d.days}
                InputProps={{
                  classes: { root: styles.smallInput }
                }}
                placeholder="50"
                onChange={e => onDaysChange(index, e)}
                style={{ margin: '0 20px' }}
              />
              <FormattedMessage
                id="predict.predictions.days"
                defaultMessage="{period}"
                values={{ period: paymentTreatment === PaymentTreatment.MULTI_PAYMENT_DAYS ? 'days' : 'weeks' }}
              />
            </div>
            <div className={styles.flexContainer}>
              <UITextField
                value={d.percentage}
                InputProps={{
                  classes: { root: styles.smallInput }
                }}
                placeholder="45"
                style={{ marginRight: 20 }}
                onChange={e => onPercentageChange(index, e)}
              />
              %
            </div>
          </>
        )} */}
        </div>
      ))}
      <div style={{ width: 56, marginLeft: 'auto', marginRight: 30 }}>
        <div className={styles.iconContainer} onClick={onAddNew}>
          <UIFeatherIcon iconName="plus" />
        </div>
      </div>
      <div
        className={clsx(styles.totalPercentage, {
          [styles.totalPercentageError]: percentageSum !== 100
        })}
      >
        <FormattedMessage id="reporting.total" defaultMessage="Total" /> {percentageSum} {'%'}
      </div>
    </div>
  );
};
